import { Link } from "react-router-dom";
import { Shell } from "./Shell";

export default function DeniedPage() {
  return (
    <Shell testid="access-denied-container">
      <div className="flex-1 flex flex-col justify-center px-6 sm:px-16">
        <div className="text-[10px] tracking-[0.4em] text-[color:var(--w1-muted)] mb-6">ERR 0x333</div>
        <h1 data-testid="access-denied-message" className="w1-display w1-glitch text-3xl sm:text-5xl lg:text-6xl leading-tight text-[color:var(--w1-red)]" style={{ textShadow: "0 0 18px rgba(255,51,51,.35)" }}>
          ACCESS DENIED —<br />SUBJECT NOT RECOGNIZED
        </h1>
        <Link to="/" onClick={(e) => { if (!window.location.hostname.endsWith("333sos.com")) { e.preventDefault(); window.location.href = "https://333sos.com"; } }}
          data-testid="access-denied-home-link" className="mt-14 text-[11px] tracking-[0.3em] text-[color:var(--w1-muted)] hover:text-[color:var(--w1-blue)] transition-colors w-fit">
          333sos.com
        </Link>
      </div>
    </Shell>
  );
}
